import { resolveClientDataActualFields } from '@/common/utils/resolveClientDataActualFields'
import type { ExchangeData } from '@/services/action/types'

export function overlayMiddleScriptUniDataOnClientDataFields(
  clientDataFields: Record<string, { value: unknown; type: string }>,
  middleScriptUniData: ExchangeData | undefined,
  toPrimitiveValue: (value: unknown) => unknown,
): void {
  if (!middleScriptUniData) return

  const snapshot = resolveClientDataActualFields(middleScriptUniData)
  for (const [key, field] of Object.entries(snapshot)) {
    if (!field || typeof field !== 'object') continue
    clientDataFields[key] = {
      value: toPrimitiveValue((field as { value?: unknown }).value),
      type: String((field as { type?: string }).type || 'String'),
    }
  }
}
